export enum ResponsabiliteDocument {
	EU = 'EU',
	EE = 'EE',
	BOTH = 'BOTH'
}
export class DocumentPaTraductionUpdateOrder {

	id!: number;
	traductionId!: number;
	responsibility!: ResponsabiliteDocument;
	autre!: string;
	customFields!: string;
	checked!: boolean;

}
